import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from '@environment';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/authentication.service";
var AccessTokenInterceptor = /** @class */ (function () {
    function AccessTokenInterceptor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    AccessTokenInterceptor.prototype.intercept = function (request, next) {
        var isLogoutRequest = request.url.endsWith('auth/logout');
        var isRefreshTokenRequest = request.url.endsWith('auth/refresh-token');
        var isLoginWithAdRequest = request.url.endsWith('auth/sign-in-with-ad');
        var isLoginWithGoogleRequest = request.url.endsWith('auth/sign-in-with-google');
        if (isLogoutRequest || isRefreshTokenRequest || isLoginWithAdRequest || isLoginWithGoogleRequest) {
            return next.handle(request);
        }
        var idToken = this.authenticationService.idToken;
        var accessToken = this.authenticationService.accessToken;
        var isRequestToUploadUrl = request.url.startsWith(environment.UPLOAD_URL);
        if (isRequestToUploadUrl && idToken) {
            request = request.clone({
                setHeaders: {
                    'authorization': "Bearer " + idToken,
                    'x-access-token': "Bearer " + idToken,
                }
            });
        }
        var isRequestToGraphql = request.url.endsWith('/graphql');
        if (isRequestToGraphql && accessToken) {
            request = request.clone({
                setHeaders: {
                    'authorization': request.headers.get('authorization') || "Bearer " + accessToken,
                    'x-access-token': request.headers.get('x-access-token') || "Bearer " + accessToken,
                    'x-client-application-name': 'mountdoom',
                    'authorizationApp': 'mountdoom'
                }
            });
        }
        var isThemirrorRequest = request.url.startsWith(environment.THE_MIRROR_URL);
        if (isThemirrorRequest && idToken) {
            request = request.clone({
                setHeaders: {
                    'authorization': "Bearer " + idToken,
                    'x-access-token': "Bearer " + idToken,
                    'X-App-Name': 'mountdoom',
                    'X-Env-Name': environment.environment
                }
            });
        }
        return next.handle(request);
    };
    AccessTokenInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AccessTokenInterceptor_Factory() { return new AccessTokenInterceptor(i0.ɵɵinject(i1.AuthenticationService)); }, token: AccessTokenInterceptor, providedIn: "root" });
    return AccessTokenInterceptor;
}());
export { AccessTokenInterceptor };
